// SBS On Demand deep-links with marketing tracking IDs.
// The colons in the cid value are intentionally unencoded — that is the
// exact form the SBS marketing team uses across their tracking pipeline.

export type SbsPlacement = "matchcentre" | "horizontalschedule";
export type SbsState = "live" | "post" | "blackbox" | "pre";

const SBS_BASE_URL = "https://www.sbs.com.au/ondemand/fifa-world-cup-2026";

export function buildSbsOnDemandUrl({
  placement,
  state,
}: {
  placement: SbsPlacement;
  state: SbsState;
}): string {
  return `${SBS_BASE_URL}?cid=sport:web:web:${placement}:bau-sport:wc26-livelike-${state}:na`;
}

export function openSbsOnDemand(args: {
  placement: SbsPlacement;
  state: SbsState;
}): void {
  window.open(buildSbsOnDemandUrl(args), "_blank", "noopener,noreferrer");
}
